import React from "react";
import "./MainSettingMenu.scss";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Box,
  Button,
  Link,
  Menu,
  MenuItem,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";

interface Props {
  attrName: any;
  value: string;
  value_update: Function;
  section: string;
}

const MainSettingMenu: React.FC<Props> = ({
  attrName,
  value,
  section,
  value_update,
}) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = React.useState<string | false>(section);
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Box className="mainSettingWrapper" sx={{ paddingTop: "90px" }}>
      <Grid container spacing={3}>
        {/* <Grid xs={12}>
          <h3 className="pageTitle mb-0 ">
            <Link
              
              onClick={() => {
                navigate("/NewSettings");
              }}>
              <ChevronLeftIcon />
            </Link>
            Modules
          </h3>
        </Grid> */}

        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="accordian-section">
              <Accordion
                className="accordian"
                expanded={expanded === "general"}
                onChange={handleChange("general")}
              >
                <AccordionSummary
                  aria-controls="1-content"
                  id="1-header"
                  className="accordion-header"
                >
                  <Typography
                    className={
                      expanded === "general"
                        ? "heading general active"
                        : "heading general "
                    }
                    sx={{}}
                  >
                    General
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className="accordian-detail-section">
                  <Typography>
                    <ul>
                      <li>
                        <Link
                          underline="none"
                          className={
                            value === "personalSettings"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "personalSettings");
                          }}
                        >
                          Personal Settings
                        </Link>
                      </li>
                      <li>
                        <Link
                          underline="none"
                          className={
                            value === "emailSettings"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "emailSettings");
                          }}
                        >
                          Email Settings
                        </Link>
                      </li>
                      <li>
                        <Link
                          underline="none"
                          className={
                            value === "appearance"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "appearance");
                          }}
                        >
                          Appearance
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                className="accordian"
                expanded={expanded === "org"}
                onChange={handleChange("org")}
              >
                <AccordionSummary
                  aria-controls="2-content"
                  id="2-header"
                  className="accordion-header"
                >
                  <Typography
                    className={
                      expanded === "org"
                        ? "heading orgnaisation active"
                        : "heading orgnaisation "
                    }
                  >
                    Organisation
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className="accordian-detail-section">
                  <Typography>
                    <ul>
                      <li>
                        <Link
                          underline="none"
                          className={
                            value === "CompanyDetails"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "CompanyDetails");
                          }}
                        >
                          Company Details
                        </Link>
                      </li>
                      <li>
                        <Link
                          underline="none"
                          className={
                            value === "Branches"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "Branches");
                          }}
                        >
                          Branches
                        </Link>
                      </li>
                      <li>
                        <Link
                          underline="none"
                          className={
                            value === "Departments"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "Departments");
                          }}
                        >
                          Departments
                        </Link>
                      </li>
                      <li>
                        <Link
                          underline="none"
                          className={
                            value === "Taxation"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "Taxation");
                          }}
                        >
                          Taxation
                        </Link>
                      </li>
                      <li>
                        <Link
                          underline="none"
                          className={
                            value === "Currencies"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "Currencies");
                          }}
                        >
                          Currencies
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* <Accordion
                className="accordian"
                expanded={expanded === "dataAdmin"}
                onChange={handleChange("dataAdmin")}
              >
                <AccordionSummary
                  aria-controls="3-content"
                  id="3-header"
                  className="accordion-header"
                >
                  <Typography
                    className={
                      expanded === "dataAdmin"
                        ? "heading dataadmin active"
                        : "heading dataadmin "
                    }
                  >
                    Data Admin
                  </Typography>
                </AccordionSummary>

                <AccordionDetails className="accordian-detail-section">
                  <Typography>
                    <ul>
                      <li>
                        <Link
                          
                          underline="none"
                          className={
                            value === "Storage"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "Storage");
                          }}
                        >
                          Storage
                        </Link>
                      </li>

                      <li>
                        <Link
                          
                          underline="none"
                          className={
                            value === "Export"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "Export");
                          }}
                        >
                          Export
                        </Link>
                      </li>
                      <li>
                        <Link
                          
                          underline="none"
                          className={
                            value === "Activity"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "ActivityLog");
                          }}
                        >
                          Activity Log
                        </Link>
                      </li>
                      <li>
                        <Link
                          
                          underline="none"
                          className={
                            value === "Audit"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "AuditLog");
                          }}
                        >
                          Audit Log
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion> */}

              <Accordion
                className="accordian"
                expanded={expanded === "userControl"}
                onChange={handleChange("userControl")}
              >
                <AccordionSummary
                  aria-controls="4-content"
                  id="4-header"
                  className="accordion-header"
                >
                  <Typography
                    className={
                      expanded === "userControl"
                        ? "heading userimg active"
                        : "heading userimg "
                    }
                  >
                    Users & Controls
                  </Typography>
                </AccordionSummary>

                <AccordionDetails className="accordian-detail-section">
                  <Typography>
                    <ul>
                      <li>
                        <Link
                          underline="none"
                          className={
                            value === "users"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "users");
                          }}
                        >
                          Users
                        </Link>
                      </li>
                      <li>
                        <Link
                          underline="none"
                          className={
                            value === "Access"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "Access");
                          }}
                        >
                          Access Control
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* <Accordion
                className="accordian"
                expanded={expanded === "custom"}
                onChange={handleChange("custom")}
              >
                <AccordionSummary
                  aria-controls="5-content"
                  id="5-header"
                  className="accordion-header"
                >
                  <Typography
                    className={
                      expanded === "custom"
                        ? "heading customisation active"
                        : "heading customisation "
                    }
                  >
                    Customisation
                  </Typography>
                </AccordionSummary>

                <AccordionDetails className="accordian-detail-section">
                  <Typography>
                    <ul>
                      <li>
                        <Link
                          
                          underline="none"
                          className={
                            value === "Modules"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "Modules");
                          }}
                        >
                          Modules
                        </Link>
                      </li>
                      <li>
                        <Link
                          
                          underline="none"
                          className={
                            value === "Templates"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "templates");
                          }}
                        >
                          Templates
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                className="accordian"
                expanded={expanded === "portalSetup"}
                onChange={handleChange("portalSetup")}
              >
                <AccordionSummary
                  aria-controls="6-content"
                  id="6-header"
                  className="accordion-header"
                >
                  <Typography
                    className={
                      expanded === "portalSetup"
                        ? "heading portalspace active"
                        : "heading portalspace "
                    }
                  >
                    Portal Setup
                  </Typography>
                </AccordionSummary>

                <AccordionDetails className="accordian-detail-section">
                  <Typography>
                    <ul>
                      <li>
                        <Link
                          
                          underline="none"
                          className={
                            value === "Employee"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "Employee");
                          }}
                        >
                          Employee Portal
                        </Link>
                      </li>
                      <li>
                        <Link
                          
                          underline="none"
                          className={
                            value === "Employer"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "Employer");
                          }}
                        >
                          Employer Portal
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                className="accordian"
                expanded={expanded === "developer"}
                onChange={handleChange("developer")}
              >
                <AccordionSummary
                  aria-controls="7-content"
                  id="7-header"
                  className="accordion-header"
                >
                  <Typography
                    className={
                      expanded === "developer"
                        ? "heading devspace active"
                        : "heading devspace "
                    }
                  >
                    Developer Space
                  </Typography>
                </AccordionSummary>

                <AccordionDetails className="accordian-detail-section">
                  <Typography>
                    <ul>
                      <li>
                        <Link
                          
                          underline="none"
                          className={
                            value === "Integrations"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "Integrations");
                          }}
                        >
                          Integrations
                        </Link>
                      </li>
                      <li>
                        <Link
                          
                          underline="none"
                          className={
                            value === "Webhooks"
                              ? "tab-button active"
                              : "tab-button"
                          }
                          onClick={() => {
                            value_update(attrName, "Webhooks");
                          }}
                        >
                          API & Webhooks
                        </Link>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MainSettingMenu;
